import React from 'react';
import { View, Dimensions, Text, Image, ScrollView, ActivityIndicator } from 'react-native';
import { CheckBox, Button, Input, Avatar } from 'react-native-elements';

import Modal from 'modal-enhanced-react-native-web';
import Lib from '../Lib';

const { IMG_DATA, USDT } = require('../Data');
const { mint, getAllowanceMint, approveMint, openExplorerTx, publishWalletData } = require('../BlockLib');

const { showToast, getStorageValue, setStorageValue } = Lib;

class PanelReward extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      show: 'busy',
      txHash: false,
      mintingFee: 10000,
      startIndex: 0,
      allowMint: 0
    };
  }

  async componentDidMount() {
    const allowMint = await getAllowanceMint();
    this.setState({ show: 'form', allowMint });
  }

  componentWillUnmount() {
  }

  async selectMintingFee(mintingFee, index) {
    this.setState({ mintingFee, startIndex: (index * 5) })
  }

  async approve() {
    try {
      const mintingFee = this.state.mintingFee;
      this.setState({ modalVisible: true, txHash: false });
      const txHash = await approveMint(mintingFee);
      const allowMint = await getAllowanceMint();
      this.setState({ txHash, allowMint });
    } catch (err) {
      if (err && err.message) showToast(err.message);
      this.setState({ modalVisible: false })
    }
  }

  async handleMint() {
    try {
      const mintingFee = this.state.mintingFee;
      this.setState({ modalVisible: true, txHash: false });
      const txHash = await mint(mintingFee);
      await publishWalletData();
      const allowMint = await getAllowanceMint();
      this.setState({ txHash, allowMint });
    } catch (err) {
      if (err && err.message) showToast(err.message);
      this.setState({ modalVisible: false })
    }
  }

  renderBusy() {
    return (
      <View style={{ flex: 1, alignItems: 'center', justifyContent: 'center' }}>
        <ActivityIndicator />
      </View>
    );
  }

  renderChance(item) {
    const imgData = IMG_DATA;
    const url = imgData[(item.index + this.state.startIndex)].img;

    const styleAvatar = { flexDirection: 'column', alignItems: 'center', justifyContent: 'center', marginHorizontal: 5 };
    return (
      <View style={styleAvatar}>
        {/* <Avatar
          rounded
          size={'large'}
          source={{
            uri: url
          }}
        /> */}
        <Image source={{
          uri: url,
        }} resizeMode="contain" style={{ width: 80, height: 80 }} />

        <Text>{item.pctg}%</Text>
      </View>);
  }

  renderModal() {
    let indicator = <ActivityIndicator />;
    let msg = 'PROCESS TX';
    if (this.state.txHash) {
      msg = 'PROCESS TX DONE';
      const txHash = this.state.txHash;
      indicator = <Button type="outline" title='OPEN ON EXPLORER' onPress={() => openExplorerTx(txHash)} />
    }

    return (
      <Modal
        isVisible={this.state.modalVisible}
        onBackdropPress={() => this.setState({ modalVisible: false })}
      >
        <View style={{ alignItems: 'center', justifyContent: 'center' }}>
          <View style={{ backgroundColor: 'white', padding: 20 }}>
            <Text> </Text>
            <Text style={{ textAlign: 'center' }}>{msg}</Text>
            <Text> </Text>
            {indicator}
            <Text> </Text>
            <Button type="outline" title='CLOSE' onPress={() => this.setState({ modalVisible: false })} />
            <Text> </Text>
          </View>
        </View>
      </Modal>
    );
  }

  render() {
    const mintEnabled = (Number(this.state.allowMint) >= this.state.mintingFee);
    let approveDisabled = mintEnabled;
    let mintDisabled = !mintEnabled;

    const ii = 0;
    const arr1 = [{ pctg: 1, index: ii + 0 }, { pctg: 7, index: ii + 1 }];
    const arr2 = [{ pctg: 13, index: ii + 2 }, { pctg: 19, index: ii + 3 }, { pctg: 60, index: ii + 4 }];
    const arr3 = [10000, 1000, 100, 10, 1];

    return (
      <View style={{ padding: 10, backgroundColor: '#eee' }}>
        {this.renderModal()}
        <Text style={{ textAlign: 'center' }}>SELECT MINTING FEE</Text>
        <Text style={{ textAlign: 'center' }}> </Text>
        {arr3.map((item, index) => {
          return (
            <CheckBox title={item + ' ' + USDT}
              checked={(this.state.mintingFee === item)}
              onPress={() => this.selectMintingFee(item, index)}
              iconType='material'
              checkedIcon='check-box'
              uncheckedIcon='check-box-outline-blank'
            />
          );
        })}
        <Text> </Text>
        <Text style={{ textAlign: 'center' }}>CHANCE</Text>
        <Text> </Text>
        <View style={{ flexDirection: 'row', justifyContent: 'center' }}>
          {arr1.map((item) => this.renderChance(item))}
        </View>
        <View style={{ flexDirection: 'row', justifyContent: 'center' }}>
          {arr2.map((item) => this.renderChance(item))}
        </View>
        <Text> </Text>
        <Text style={{ textAlign: 'center' }}>BURN LATER TO RETRIEVE 100% MINTING FEE BACK</Text>
        <Text style={{ textAlign: 'center' }}>(5% PINALTY WHEN BURN BEFORE 30 DAYS)</Text>
        <Text> </Text>
        <View style={{ flexDirection: 'row' }}>
          <View style={{ flex: 1 }}><Button disabled={approveDisabled} title="APPROVE" onPress={() => this.approve()} /></View>
          <View style={{ width: 10 }} />
          <View style={{ flex: 1 }}><Button disabled={mintDisabled} title="MINT" onPress={() => this.handleMint()} /></View>
        </View>
        <Text> </Text>
        <View style={{ flexDirection: 'row' }}>
          <View style={{ flex: 1 }}><Button type="outline" title="BACK" onPress={() => this.props.handleHome()} /></View>
        </View>
      </View>
    );
  }

}

export default PanelReward;
